// @ts-check

/** Currency symbol lookup. Unlisted codes fall back to the code itself. */
export const SYMBOL_MAP = new Map([
  ['USD', '$'],
  ['AED', 'AED'],
  ['CAD', 'CA$'],
  ['EUR', '€'],
  ['GBP', '£'],
]);

/** Locale hint per currency for Intl formatting. */
const LOCALE_MAP = new Map([
  ['AED', 'en-AE'],
  ['USD', 'en-US'],
  ['CAD', 'en-CA'],
  ['EUR', 'de-DE'],
  ['GBP', 'en-GB'],
]);

/** @type {Map<string, Intl.NumberFormat>} */
const formatterCache = new Map();

/**
 * Format a numeric amount with the correct currency symbol and thousands separators.
 * Uses Intl.NumberFormat for proper locale-aware formatting.
 * @param {number} amount
 * @param {string} currencyCode
 * @returns {string}
 */
export const formatCurrency = (amount, currencyCode = 'USD') => {
  const code = (currencyCode || 'USD').toUpperCase();
  let fmt = formatterCache.get(code);
  if (!fmt) {
    const locale = LOCALE_MAP.get(code) || 'en-US';
    try {
      fmt = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: code,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } catch {
      // Fallback for unknown currency codes
      fmt = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      formatterCache.set(code, fmt);
      return `${code} ${fmt.format(amount)}`;
    }
    formatterCache.set(code, fmt);
  }
  return fmt.format(amount);
};
